// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatarseth } from "../../../icons/full/build/icon-statarseth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatarsethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatarseth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatarsethIcon.displayName = 'StatarsethIcon';
}

export default StatarsethIcon;